module.exports = __webpack_public_path__ + "img/DSC1953.661337fb.jpg";